exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".main-schedule-1{fill:#afdedb;}\n.main-schedule-2{fill:#fff;}\n.main-schedule-3{fill:#014f6d;}", ""]);
